// import React, { Component } from 'react'
// import QBuilderLayoutComponentWrapper from '../../../builder/Wizard/Layouts/QBuilderLayoutComponentWrapper'
// import '../QCapture.css'
// import QCaptureComponentWrapper from './QCaptureComponentWrapper'
import { Component, useContext } from 'react'
import QuestionnaireBuilderContext from '../../../builder/QuestionnaireBuilderProvider'
import QBuilderLayoutComponentWrapper from '../../../builder/Wizard/Layouts/QBuilderLayoutComponentWrapper'
import QCaptureComponentWrapper from './QCaptureComponentWrapper'

export default class QFormLayout extends Component {
	constructor(props) {
		super(props)
		this.state = {
			details: { ...props.details },
			formData: props.formData,
			navigation: [],
		}

	}

	_sortSections(sections) {
		return [...(sections || [])].sort((a, b) => {
			const ao = Number.isFinite(Number(a?.resource?.resource?.order)) ? Number(a.resource.resource.order) : Number.MAX_SAFE_INTEGER
			const bo = Number.isFinite(Number(b?.resource?.resource?.order)) ? Number(b.resource.resource.order) : Number.MAX_SAFE_INTEGER
			return ao - bo
		})
	}

	_sortComponents(components) {
		const getAxis = (component, axis) => {
			try {
				const layoutValue = component?.resource?.properties?.find(p => p.property === 'Layout')?.values
				if (!layoutValue) return Number.MAX_SAFE_INTEGER
				const parsed = JSON.parse(layoutValue)
				const value = parsed?.[axis]
				return Number.isFinite(Number(value)) ? Number(value) : Number.MAX_SAFE_INTEGER
			} catch (e) {
				return Number.MAX_SAFE_INTEGER
			}
		}

		return [...(components || [])].sort((a, b) => {
			const ay = getAxis(a, 'y')
			const by = getAxis(b, 'y')
			if (ay !== by) return ay - by
			const ax = getAxis(a, 'x')
			const bx = getAxis(b, 'x')
			if (ax !== bx) return ax - bx
			const ao = Number.isFinite(Number(a?.resource?.order)) ? Number(a.resource.order) : Number.MAX_SAFE_INTEGER
			const bo = Number.isFinite(Number(b?.resource?.order)) ? Number(b.resource.order) : Number.MAX_SAFE_INTEGER
			return ao - bo
		})
	}

	/*
		Section
	*/
	_renderSections(sections) {
		var ret = []
		for (var i = 0; i < this._sortSections(sections).length; i++) {
			ret.push(
				<div
					className={"section flex-column align-items-stretch w-100 "}>{this._renderSection(this._sortSections(sections)[i])}</div>)
		}
		return ret
	}

	_renderSection(section) {
		const SHOW_TITLE = this.state.details.options.find(o => o.name === "SHOW_SECTION_TITLE")
		// alert(JSON.stringify(this.state.details.options))
		var section_title = section.resource.resource.name
		if (SHOW_TITLE) {
			var SHOW_TITLE_parsed = JSON.parse(SHOW_TITLE.value)

			if (SHOW_TITLE_parsed === "Hide") {
				section_title = "";
			}
		}
		var _section_details = section_title ? <h3 style={{ position: 'sticky', top: '0px',zIndex: 10 }} className='bg-secondary-container text-center p-2 shadow'>{section_title}</h3> : <></>
		var _section_components = this._renderComponents(this._sortComponents(section.resources), section)
		return (<div className='text-start'>{_section_details}{_section_components}</div>)



		// var _section_components = this._renderComponents(section.resources, section)
		// return (<div className='text-start'>{_section_components}</div>)
	}
	/*
		Components
	*/
	_checkLayout(component) {
		var _width = 12
		var _offset = 0
		var _layout = []
		try {
			var layout = component.properties.find(p => p.property === 'Layout').values
			if (layout) {
				_layout = JSON.parse(layout)
				_width = _layout.width
				_offset = _layout.offset
			}
		} catch (e) { layout = undefined }
		return { width: _width, offset: _offset, layout: _layout }
	}

	_renderComponents(components, section) {
		var ret = []
		var comps = []
		var _cur_row_width = 0;
		for (const component of components) {
			if (!component.resource) continue
			// var _cache = undefined
			// if (this.props.cachedDetails) {
			// var _component_cached = undefined
			// try {

			// const _sections_filter = JSON.parse(JSON.stringify(this.props.cachedDetails.questionnaire.sections));
			// const _section_cache = _sections_filter
			// .find(s => s.id === section.id)
			// _component_cached =
			// _section_cache.components.find(c => c.id === component.id)
			// } catch (e) { }

			// var _component_responses = { answer: '' }
			// try {
			// var _response = this.props.cachedDetails.responses.find(r => r.answerType.id === component.id)
			// _component_responses = _response ? _response : { answer: '' }
			// } catch (e) {
			// _component_responses = { answer: '' }
			// }
			// var _component_alerts = undefined
			// try {
			// _component_alerts = this.props.cachedDetails.alerts
			// } catch (e) { }

			// _cache = {
			// properties: _component_cached && Object.keys(_component_cached).includes('properties') ? _component_cached.properties : undefined,
			// response: _component_responses,
			// alerts: _component_alerts
			// }
			// }
			const layout = this._checkLayout(component.resource)
			_cur_row_width += layout.width + layout.offset
			comps.push(<QBuilderLayoutComponentWrapper
				currentMode={'Capture'}
				onUpdateLayout={(layout) => { }}
				defaultLayout={layout.layout}
				className={'col-' + layout.width + ' offset-' + layout.offset}
			>
				<QCaptureComponentWrapper
					state={this.state}
					mode={this.props.mode}
					view={this.props.view}//this.props.view
					accessTypes={component.accessTypes}
					// cache={_cache}
					component={component.resource}
					onSetData={(componentId, value, update) => this.props.onSetData(componentId, value, update)}
					activeSubsections={this.props.activeSubsections}
				/>
			</QBuilderLayoutComponentWrapper>)

			if (_cur_row_width >= 12) {
				ret.push(<div className='row'>{comps}</div>)
				comps = []
				_cur_row_width = 0
			}
		}
		ret.push(<div className='row'>{comps}</div>)
		return ret
	}

	/*
		Navigation
	*/
	_handleValidateEvent() {
		var res = true
		for (const fd of this.state.formData) {
			if (fd.section === this.state.step)
				if (fd.validate && !fd.valid)
					res = false
		}
		return res
	}

	_handleNavigation() {
		// Dont show in discover mode
		if (this.props.mode === 'Discover' || this.props.mode === 'Form')
			return <></>
		// Check Validation
		// Done
		return (
			<>
				<ValidateNext text='Save' onClick={(e) => {
					// Check complete
					// console.log((this.state.step ?? 0) + 1,this.state.details.questionnaire.resources)
					// if ((this.state.step ?? 0) + 1 === this.state.details.questionnaire.resources.length)
						this.props.onComplete()
					// alert((this.state.step ?? 0) + 1 === this.state.details.questionnaire.resources.length) // ALERT HERE
					this.setState({ step: this.state.step + 1 })
				}} className={`btn ng-buttons ${this._handleValidateEvent() ? '' : 'disabled'})`} />
			</>
		)
	}

	_handleTitle() {
		var section_title = ''
		try {
			const SHOW_TITLE = this.state.details.options.find(o => o.name === "SHOW_TITLE")
			section_title = this.state.details.questionnaire.resource.resource.name
			if (SHOW_TITLE) {
				var SHOW_TITLE_parsed = JSON.parse(SHOW_TITLE.value)
				if (SHOW_TITLE_parsed === "None") {
					section_title = "";
				}
				else if (SHOW_TITLE_parsed.type === "Custom Title") {
					section_title = SHOW_TITLE_parsed.title;
				}
			}
		} catch (e) { }
		return section_title ? <h1 className='text-center bg-primary-container m-0 p-1 rounded-top'>{section_title}</h1> : <></>
	}

	_handleDescription() {
		var section_title = ''
		try {
			const SHOW_TITLE = this.state.details.options.find(o => o.name === "SHOW_SECTION_TITLE")
			var section_name = this.state.details.questionnaire.resources[this.state.step].resource.resource.name
			if (SHOW_TITLE) {
				var SHOW_TITLE_parsed = JSON.parse(SHOW_TITLE.value)
				if (SHOW_TITLE_parsed.type === "Hide") {
					section_name = "";
				}
			}
			return section_name
		} catch (e) { }
		return section_title
	}

	render() {
		return (
			<div className={'d-flex flex-column h-100 '.concat(this.props.view)}>
				{/* <ToastDialog {...status} />
				<ErrorDialog error={errors} onClose={() => setErrors('')} /> */}
				{/* <div
					className="Wizard top-center position-relative">
					<div className="head"><h1>{this._handleTitle()}</h1>
						<p dangerouslySetInnerHTML={{ __html: this._handleDescription() }}></p>
						<div
							className="error-details"></div>
					</div>
					<div className="body"> */}


				<div className='flex-grow-1' style={{ overflow: 'auto' }}>
					{this._handleTitle()}
					{
						this._renderSections(this.state.details.questionnaire.resources.filter(s =>
							(
								s.resource.accessTypes.includes('View')
								|| s.resource.accessTypes.includes('Edit')
								|| s.resource.accessTypes.includes('Inherit')

							) && s.resource.resource.isSubsection === false
						))
					}
				</div>
				{/* </div> */}
				<div className="text-center" style={{ minHeight: '38px' }}>
					{
						this._handleNavigation()
					}
				</div>
				{/* </div> */}
			</div>
		)
	}
}


const ValidateNext = ({ text, onClick, className }) => {
	const { validated } = useContext(QuestionnaireBuilderContext)
	return <button
		// disabled={!this._handleValidateEvent()}
		disabled={!validated}
		onClick={onClick}
		className={`${className} ${!validated ? 'disabled' : ''}`}>{text}</button>
}



// export default class QFormLayout extends Component {
// constructor(props) {
// super(props)
// this.state = {
// details: { ...props.details },
// formData: props.formData
// }
// }

// _handleValidateEvent() {
// if (this.props.mode === 'Discover')
// return false
// var res = true
// for (const fd of this.state.formData) {
// if (fd.validate && !fd.valid)
// res = false
// }
// return res
// }

// /*
// Section
// */
// _renderSections(sections) {
// var ret = []
// for (const section of sections) {
// ret.push(this._renderSection(section))
// }
// // this.setState({ formData: _formData })
// return ret
// }
// _renderSection(section) {
// const SHOW_TITLE = this.state.details.options.find(o => o.name === "SHOW_SECTION_TITLE")
// var section_title = section.name
// if (SHOW_TITLE) {
// var SHOW_TITLE_parsed = JSON.parse(SHOW_TITLE.value)
// if (SHOW_TITLE_parsed.type === "Hide") {
// section_title = "";
// }
// }
// var _section_details = section_title ? <h3 className='bg-secondary-container text-center p-2 shadow'>{section_title}</h3> : <></>
// var _section_components = this._renderComponents(section.components, section)

// return (<div className='text-start'>{_section_details}{_section_components}</div>)
// }
// /*
// Components
// */
// _checkLayout(component) {
// var _width = 12
// var _offset = 0
// var _layout = []
// try {
// var layout = component.properties.find(p => p.property === 'Layout').values
// if (layout) {
// _layout = JSON.parse(layout)
// _width = _layout.width
// _offset = _layout.offset
// }
// } catch (e) { layout = undefined }
// return { width: _width, offset: _offset, layout: _layout }
// }

// _renderComponents(components, section) {
// var ret = []
// var comps = []
// var _cur_row_width = 0;

// for (const component of components) {
// var _cache = undefined
// if (this.props.cachedDetails) {
// var _component_cached = undefined
// try {
// const _sections_filter = JSON.parse(JSON.stringify(this.props.cachedDetails.questionnaire.sections));
// const _section_cache = _sections_filter
// .find(s => s.id === section.id)
// _component_cached =
// _section_cache.components.find(c => c.id === component.id)
// } catch (e) { }

// var _component_responses = { answer: '' }
// try {
// var _response = this.props.cachedDetails.responses.find(r => r.answerType.id === component.id)
// _component_responses = _response ? _response : { answer: '' }
// } catch (e) {
// _component_responses = { answer: '' }
// }
// var _component_alerts = undefined
// try {
// _component_alerts = this.props.cachedDetails.alerts
// } catch (e) { }
// _cache = {
// properties: _component_cached && Object.keys(_component_cached).includes('properties') ? _component_cached.properties : undefined,
// response: _component_responses,
// alerts: _component_alerts
// }
// }

// const layout = this._checkLayout(component)

// _cur_row_width += layout.width + layout.offset
// comps.push(<QBuilderLayoutComponentWrapper
// currentMode={'Capture'}
// onUpdateLayout={(layout) => { }}
// defaultLayout={layout.layout}
// className={'col-' + layout.width + ' offset-' + layout.offset}
// >
// <QCaptureComponentWrapper
// state={this.state}
// cache={_cache}
// mode={this.props.mode}
// view={this.props.view}
// component={component}
// onSetData={(componentId, value, update) => this.props.onSetData(componentId, value, update)}
// activeSubsections={this.props.activeSubsections}
// />
// </QBuilderLayoutComponentWrapper>)

// if (_cur_row_width >= 12) {
// ret.push(<div className='row'>{comps}</div>)
// comps = []
// _cur_row_width = 0
// }
// }
// ret.push(<div className='row'>{comps}</div>)
// return ret
// }

// _handleTitle() {
// var section_title = ''
// try {
// const SHOW_TITLE = this.state.details.options.find(o => o.name === "SHOW_TITLE")
// section_title = this.state.details.questionnaire.name
// if (SHOW_TITLE) {
// var SHOW_TITLE_parsed = JSON.parse(SHOW_TITLE.value)
// if (SHOW_TITLE_parsed.type === "None") {
// section_title = "";
// }
// else if (SHOW_TITLE_parsed.type === "Custom Title") {
// section_title = SHOW_TITLE_parsed.title;
// }
// }
// } catch (e) { }
// return section_title ? <h1 className='text-center bg-primary-container m-0 p-1 rounded-top'>{section_title}</h1> : <></>
// }

// render() {
// if (this.state.details)
// return (
// <div className={'d-flex flex-column h-100 '.concat(this.props.view)}>
// <div className='flex-grow-1' style={{ overflow: 'auto' }}>
// {this._handleTitle()}
// {
// this._renderSections(this.state.details
// .questionnaire
// .sections.filter(s => s.isSubsection === false))
// }
// </div>
// <div className='flex-shrink-1 text-center' style={{ minHeight: '50px' }}>
// {
// this.props.mode === 'Discover'
// ?
// <></>
// :
// this.props.mode !== 'Form'
// ?
// <button type='button' onClick={(e) => this.props.onComplete()} className={'btn bg-primary-container '.concat(this._handleValidateEvent() ? '' : 'disabled')} > Complete</button>
// :
// <></>
// }
// </div>
// </div >
// )
// }
// }

